/**
 * Order Module Utility Functions
 */
import { KYC_FLOW_UPLOAD_DOC, KYC_FLOW_VERIFY } from "./OrderConstants";

export const KYC_ALLOWED_OEM_IDS = [9];

/**
 * Maps raw backend / provider KYC status to user-friendly status labels.
 *
 * @param {Object} data - Order or member CKYC response object
 * @returns {string} Formatted status ("KYC Verification Successful" | "KYC Verification Failed" | "KYC Verification Pending")
 */
export const formatKycStatus = (data) => {
  if (!data) return "KYC Verification Pending";

  const rawKycStatus = String(
    data.kyc_status || data.member_ckyc?.kyc_status || ""
  )
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  const finalStatus = String(
    data.final_status ?? data.member_ckyc?.final_status ?? ""
  );
  const isKyc = data.is_kyc;

  // 1. Success / Completed
  if (
    isKyc === true ||
    isKyc === 1 ||
    isKyc === "1" ||
    isKyc === "true" ||
    [
      "completed",
      "verified",
      "success",
      "successful",
      "kycverificationsuccessful",
    ].includes(rawKycStatus) ||
    finalStatus === "1" ||
    finalStatus === "3"
  ) {
    return "KYC Verification Successful";
  }

  // 2. Failed / Rejected
  if (
    [
      "failed",
      "rejected",
      "error",
      "kycverificationfailed",
    ].includes(rawKycStatus) ||
    finalStatus === "0"
  ) {
    return "KYC Verification Failed";
  }

  // 3. Default: Pending
  return "KYC Verification Pending";
};

/**
 * Best-effort message text out of an API error response, whatever shape the
 * body came back in.
 */
export const extractErrorMessage = (error) => {
  const data = error?.response?.data;
  if (typeof data === "string") return data;
  return data?.error_message || data?.message || data?.error || "";
};


export const resolveEnabledKycFlows = (config) => {
  const flows = [];
  if (config?.upload_doc_enabled === true) flows.push(KYC_FLOW_UPLOAD_DOC);
  if (config?.verify_enabled === true) flows.push(KYC_FLOW_VERIFY);
  return flows;
};


export const isFlowDisabledError = (error) => {
  if (error?.response?.status !== 400) return false;
  return extractErrorMessage(error).toLowerCase().includes("is disabled");
};
